import * as FileSaver from "file-saver";

export class ReportsExportExcelService {
    /**
     *
     */
    public static exportAsExcel(exportType: 'XLS' | 'XLSX', dataResult: any, organizationName: any, reportName: any) {
        if (exportType === "XLSX") {
            import("xlsx").then(xlsx => {
                const worksheet = xlsx.utils.json_to_sheet(dataResult);
                const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                this.saveAsExcelFilexlsx(excelBuffer, reportName);
            });
        }
        else if (exportType === "XLS") {
            import("xlsx").then(xlsx => {
                const worksheet = xlsx.utils.json_to_sheet(dataResult);
                const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                const excelBuffer: any = xlsx.write(workbook, { bookType: 'xls', type: 'array' });
                this.saveAsExcelFilexls(excelBuffer, reportName);
            });
        }
    }
    //XLS
    private static saveAsExcelFilexls(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xls';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    //XLSX
    private static saveAsExcelFilexlsx(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
}
